// extracted by mini-css-extract-plugin
module.exports = {"panelTitle":"panelTitle--SmartListPostingForm-components__2I6xJ"};